import { IBatch } from '@/features/single-measurement/types';

import { getBatchImages } from '../get-batch-images';
import { getHistogramGraph } from '../get-histogram-graph';
import { getDataTable } from './get-data-table';

export type PDFBatchFormatType = {
  table: JSX.Element;
  images: {
    taskId: string;
    batchId: string;
    imageType: string;
    image: Blob;
  }[];
  histogram: Blob | undefined;
};

export const formatBatchData = async (
  batches: IBatch[],
): Promise<PDFBatchFormatType[]> => {
  const data = [];
  for (const batch of batches) {
    const table = getDataTable(batch);
    const images = await getBatchImages(batch);
    const histogram = await getHistogramGraph(batch);
    data.push({ table, images, histogram });
  }
  return data;
};
